import { useState, useEffect } from 'react';

const MOBILE_BREAKPOINT = 768;

const getIsMobileOrPWA = (): boolean => {
  if (typeof window === 'undefined') return false;
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
  const isIOSStandalone = (window.navigator as any).standalone === true;
  const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;
  return isStandalone || isIOSStandalone || isMobile;
};

export default function useIsPWA(): boolean {
  const [isPWA, setIsPWA] = useState(getIsMobileOrPWA);

  useEffect(() => {
    const standaloneMql = window.matchMedia('(display-mode: standalone)');
    const onStandaloneChange = () => setIsPWA(getIsMobileOrPWA());
    standaloneMql.addEventListener('change', onStandaloneChange);

    const onResize = () => setIsPWA(getIsMobileOrPWA());
    window.addEventListener('resize', onResize);

    return () => {
      standaloneMql.removeEventListener('change', onStandaloneChange);
      window.removeEventListener('resize', onResize);
    };
  }, []);

  return isPWA;
}
